﻿import * as React from 'react';

import { merge } from 'utils';

import 'components/Input/input.scss';

interface InputProps{
	className?: string,
	label?: string,
	maxLength?: number;
	onChange?: (newValue: string) => void
	tabbable?: boolean,
	textarea?: boolean;
	type?: string
	value?: string | number
}

/**@deprecated Use KendoReact Input instead. */
const Input = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, InputProps>(({ className, label, maxLength, onChange, tabbable = true, textarea, type, value }: InputProps, ref) => (
    <label className={merge('gm-input', className)}>
        {label && (
        <div className="gm-input--label">
            {label}
        </div>
        )}
        {textarea
            ? (
                <textarea
                    className={merge('gm-input--control', 'var-textarea')}
                    maxLength={maxLength}
                    onChange={e => onChange?.(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                    ref={(ref as React.MutableRefObject<HTMLTextAreaElement>)}
                    tabIndex={tabbable ? 0 : -1}
                    value={value}
                />
            )
            : (
                <input
                    className="gm-input--control"
                    maxLength={maxLength}
                    onChange={e => onChange?.(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                    ref={(ref as React.MutableRefObject<HTMLInputElement>)}
                    tabIndex={tabbable ? 0 : -1}
                    type={type}
                    value={value}
                />
            )
        }
    </label>
));

export { Input };